import Mail from '../../public/assets/email.png'
import {socialData} from "../utils/data.jsx";
import {useState} from "react";
import Contact from "./Contact.jsx";

const Footer = () => {
	const [contact, setContact] = useState(false);

	const handleContact = () => {
		setContact(true);
	}

	return (
		<footer className="sticky border-gray-300 left-0 top-0 h-auto flex items-center justify-center xl:justify-end xl:h-screen py-5 xl:px-10 xl:border-0">
			<ul className="flex flew-row xl:flex-col gap-4">
				{socialData.map((item, index) => (
					<li key={index}>
						<a href={item.href} download={item.download} target="_blank" rel="noreferrer">
							<img src={item.icon} alt={item.alt}
									 className="w-8 h-8 rounded-full bg-gray-300 hover:w-14 hover:h-14 hover:bg-white transition-all duration-300 p-1"/>
						</a>
					</li>
				))}
				<li onClick={handleContact}>
					<img src={Mail} alt="email_send_icon"
							 className="w-8 h-8 rounded-full bg-gray-300 hover:w-14 hover:h-14 hover:bg-white transition-all duration-300 p-1 cursor-pointer"/>
				</li>
			</ul>
			{contact && (
				<Contact onClose={() => setContact(false)}/>
			)}
		</footer>
	)
}

export default Footer;